/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx } from '@ba-ui-toolkit/utils';

export default class Row extends Component {
	static propTypes = {
		colToAddScopeRow: PropTypes.number,
		cellRenderer: PropTypes.func,
		className: PropTypes.string,
		colLength: PropTypes.number,
		headerRenderer: PropTypes.func,
		headerRow: PropTypes.bool,
		onRowHover: PropTypes.func,
		onRowOut: PropTypes.func,
		onRef: PropTypes.func,
		rowKey: PropTypes.number,
		style: PropTypes.object,
		widthDivision: PropTypes.object,
		onRowClick: PropTypes.func,
	};
	constructor(props) {
		super(props);
		this.state = {
			selected: false,
		};
	}
	componentDidMount() {
		this.props.onRef && this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef && this.props.onRef(undefined);
	}
	onSelect() {
		this.setState({
			selected: !this.state.selected,
		});
	}
	_onHover = () => {
		this.props.onRowHover && this.props.onRowHover(this.props.rowKey);
	};
	_onLeave = () => {
		this.props.onRowOut && this.props.onRowOut(this.props.rowKey);
	};
	_onClick = () => {
		this.props.onRowClick && this.props.onRowClick(this.props.rowKey);
	};
	_renderRows = () => {
		let count = 0;
		let totalWidth = 0;
		// accessibility requirement to add scope as row
		const { colToAddScopeRow } = this.props;
		if (this.props.widthDivision) {
			Object.keys(this.props.widthDivision).forEach(index => {
				totalWidth += parseInt(this.props.widthDivision[index].split('px')[0], 0);
				count++;
			});
		}
		totalWidth += 'px';
		if (!this.props.headerRow) {
			return Array(this.props.colLength)
				.fill()
				.map((item, colIndex) => {
					let width = '';
					if (this.props.widthDivision && this.props.widthDivision[colIndex]) {
						width = this.props.widthDivision[colIndex];
					} else {
						width = `calc((100% - ${totalWidth}) / ${this.props.colLength - count})`;
					}
					let tdScope = {};
					if (colIndex === colToAddScopeRow) {
						tdScope = {
							scope: 'row',
						};
					}

					return (
						<td
							style={{
								minWidth: width,
								maxWidth: width,
								width,
							}}
							key={colIndex}
							{...tdScope}
						>
							{this.props.cellRenderer &&
								this.props.cellRenderer(this.props.rowKey, colIndex)}
						</td>
					);
				});
		}

		return Array(this.props.colLength)
			.fill()
			.map((item, colIndex) => {
				let width = '';
				if (this.props.widthDivision && this.props.widthDivision[colIndex]) {
					width = this.props.widthDivision[colIndex];
				} else {
					width = `calc((100% - ${totalWidth}) / ${this.props.colLength - count})`;
				}

				return (
					<th
						style={{
							minWidth: width,
							maxWidth: width,
							width,
						}}
						key={colIndex}
						scope="col"
					>
						{this.props.headerRenderer && this.props.headerRenderer(colIndex)}
					</th>
				);
			});
	};
	render() {
		const { className, style } = this.props;
		const { selected } = this.state;
		const classNames = cx({
			selected,
		});

		return (
			<tr
				style={style}
				className={`${classNames} ${className}`}
				onClick={() => {
					this._onClick();
				}}
				onMouseOver={() => {
					this._onHover();
				}}
				onMouseOut={() => {
					this._onLeave();
				}}
			>
				{this._renderRows()}
			</tr>
		);
	}
}
